"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const device_1 = require("@completeanatomy/device");
const getHost_1 = require("../../../utils/getHost");
const diversity_screen_1_xray_mp4_1 = __importDefault(require("../../assets/videos/diversity-screen-1-xray.mp4"));
const TitleSubtitleDiversity_1 = __importDefault(require("../../atoms/TitleSubtitleDiversity"));
const subtitle = [
    (0, i18n_1.Localized)(i18n_1.Strings.diversity.firstPage.subtitle),
];
function DiversityOnboarding() {
    const { t } = (0, react_i18next_1.useTranslation)();
    const CNRegion = (0, device_1.useIsCNRegion)();
    const host = (0, getHost_1.getHost)(CNRegion);
    const learnMoreLink = `https://${host}/blog/diversity-inclusion-vision`;
    return ((0, jsx_runtime_1.jsxs)(ContentContainer, { "data-e2e": 'DiversityOnboarding_ContentContainer', children: [(0, jsx_runtime_1.jsx)(TitleSubtitleDiversity_1.default, { title: (0, i18n_1.Localized)(i18n_1.Strings.diversity.firstPage.title), subtitle: subtitle, "data-e2e": 'DiversityOnboarding_TitleSubtitleDiversity' }), (0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'DiversityOnboarding_Container', children: [(0, jsx_runtime_1.jsxs)(LinkContainer, { "data-e2e": 'DiversityOnboarding_LinkContainer', children: [(0, jsx_runtime_1.jsx)(ShortLink, { link: learnMoreLink, title: t(i18n_1.Strings.tips.learnMore), "data-e2e": 'DiversityOnboarding_ShortLink' }), (0, jsx_runtime_1.jsx)(LongLink, { link: learnMoreLink, title: t(i18n_1.Strings.diversity.link), "data-e2e": 'DiversityOnboarding_LongLink' })] }), (0, jsx_runtime_1.jsx)(Video, { preload: "auto", loop: true, autoPlay: true, muted: true, playsInline: true, "data-testid": "diversityVideo", "data-e2e": 'DiversityOnboarding_Video', children: (0, jsx_runtime_1.jsx)("source", { src: diversity_screen_1_xray_mp4_1.default, type: "video/mp4", "data-e2e": 'DiversityOnboarding_source' }) })] })] }));
}
exports.default = DiversityOnboarding;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  margin: 0 auto 10px auto;

  ${ui_1.devicePortrait.tablet((0, styled_components_1.css) `
    display: flex;
  `)};

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    height: 90vh;
    margin: auto;
  `)};

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    display: flex;
  `)};
`;
const LinkContainer = styled_components_1.default.div `
  ${ui_1.devicePortrait.tablet((0, styled_components_1.css) `
    height: 10vh;
  `)};
`;
const Video = styled_components_1.default.video `
  width: 100%;
  max-width: 414px;
  height: 280px;

  margin: 20px auto;
  object-fit: cover;

  ${ui_1.devicePortrait.tablet((0, styled_components_1.css) `
    margin: 0 auto;
    width: 528px;
    max-width: 528px;
    height: 422px;
  `)};

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    margin: 0 auto;
    width: 360px;
    height: 270px;
  `)};

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    margin: 0 auto;
    width: 528px;
    max-width: 528px;
    height: 422px;
  `)};

  &::-webkit-media-controls {
    display: none;
  }
`;
const LongLink = (0, styled_components_1.default)(ui_1.LearnMoreLink) `
  display: none;

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    display: block;

    margin: 10px auto 30px;
  `)}

  ${ui_1.deviceLandscape.laptop((0, styled_components_1.css) `
    margin: 20px auto 30px;
  `)}
`;
const ShortLink = (0, styled_components_1.default)(ui_1.LearnMoreLink) `
  display: none;

  ${ui_1.devicePortrait.mobileS((0, styled_components_1.css) `
    display: block;
  `)}

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    display: none;
  `)}
`;
const ContentContainer = styled_components_1.default.div `
  position: static;
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  align-items: center;

  overflow-y: scroll;
  overflow-x: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  ${ui_1.devicePortrait.mobileS((0, styled_components_1.css) `
    flex-direction: column;
    height: 84vh;
    width: 100vw;
  `)}

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    height: 92vh;
    flex-direction: column;
  `)}
  
  ${ui_1.deviceLandscape.laptop((0, styled_components_1.css) `
    height: 86vh;
  `)}
  
  ${ui_1.deviceLandscape.laptopL((0, styled_components_1.css) `
    height: 70vh;
    margin-bottom: 140px;
  `)};
`;
